import apiClient from '../apiClient';

/**
 * Get all customer categories
 * Uses the query-side lookup endpoint
 */
export const getCustomerCategories = async () => {
    try {
        const response = await apiClient.get('/lookups/customer-categories');
        return response.data;
    } catch (error) {
        console.error('Error fetching customer categories:', error);
        throw error;
    }
};

/**
 * Create a new customer category
 * Uses the command-side endpoint
 */
export const createCustomerCategory = async (name) => {
    try {
        const response = await apiClient.post('/customer-categories', { name });
        return response.data;
    } catch (error) {
        console.error('Error creating customer category:', error);
        throw error;
    }
};

/**
 * Update an existing customer category
 */
export const updateCustomerCategory = async (publicId, name) => {
    try {
        const response = await apiClient.put(`/customer-categories/${publicId}`, { name });
        return response.data;
    } catch (error) {
        console.error('Error updating customer category:', error);
        throw error;
    }
};

/**
 * Get all sales persons
 */
export const getSalesPersons = async () => {
    try {
        const response = await apiClient.get('/lookups/sales-persons');
        return response.data;
    } catch (error) {
        console.error('Error fetching sales persons:', error);
        throw error;
    }
};

/**
 * Get all countries
 */
export const getCountries = async () => {
    try {
        const response = await apiClient.get('/lookups/countries');
        return response.data;
    } catch (error) {
        console.error('Error fetching countries:', error);
        throw error;
    }
};

/**
 * Get states for a specific country
 */
export const getStatesByCountry = async (countryPublicId) => {
    try {
        const response = await apiClient.get(`/lookups/countries/${countryPublicId}/states`);
        return response.data;
    } catch (error) {
        console.error('Error fetching states:', error);
        throw error;
    }
};

/**
 * Get all business categories
 */
export const getBusinessCategories = async () => {
    try {
        const response = await apiClient.get('/lookups/business-categories');
        return response.data;
    } catch (error) {
        console.error('Error fetching business categories:', error);
        throw error;
    }
};
